import { useWindowWidth } from '@react-hook/window-size';
import { Breakpoints, Layout, styled } from '@volkswagen-onehub/components-core';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { isCommercial, isPrivate } from 'src/bff/get-data-url';
import { OfferCarlineCard, OfferContainer } from 'src/components';
import { getDataServiceConfig, useInfoPageService } from 'src/feature-app';
import {
  Alias,
  useDisclaimerReference,
  useFaContent,
  useFeatureAppConfig,
  useFeatureServices,
  useTrackingManager,
  useMaxWidthFunc,
} from 'src/feature-app/hooks';
import { CarlineWithOffers } from 'src/types';
import { useViewportWidth } from '../MofaCarousel';
import { OffersState } from '../redux/reducer';
import { setGlobalDisclaimer } from '../utils';
import { useNavigate } from 'react-router-dom';
import { useHistory } from 'react-router';

const MaxWidthLayout = styled.div<{ useMaxWidth: boolean }>`
  width: 100%;
  max-width: ${(props) => (props.useMaxWidth ? '1920px' : null)};
  margin: auto;
`;

const OffersLineWrapper = styled.div`
  width: 100%;
  padding-bottom: 56px;
  @media all and (min-width: 560px) {
    display: flex;
    padding-bottom: 68px;
  }
  @media all and (min-width: 1600px) {
    padding-bottom: 84px;
  }

  &.last-row {
    padding-bottom: 0;
  }

  &.showing-offers {
    @media all and (min-width: 560px) {
      padding-bottom: 52px;
    }
    @media all and (min-width: 1600px) {
      padding-bottom: 64px;
    }
  }
`;
const OfferCarlineWrapper = styled.div`
  @media all and (min-width: 560px) {
    margin-right: 7vw;
  }
  @media all and (min-width: 960px) {
    margin-right: 4.1vw;
  }
  @media all and (min-width: 1600px) {
    margin-right: 2.4vw;
  }
  @media all and (min-width: 1920px) {
    margin-right: 70.4933px;
  }
`;
export interface HomePageProps {
  offers: CarlineWithOffers[];
}

const findCarlineIndex = (offerRows: any[], carlineCode: number) =>
  offerRows.findIndex((row: any[]) => row.find((offer: CarlineWithOffers) => offer.code === carlineCode));
const findCarlineInOffers = (offers: CarlineWithOffers[], carlineName: string) =>
  offers.find((offer) => offer.name === carlineName);

const getDisclaimers = (carlines: CarlineWithOffers[]): string[] => {
  return carlines
    .map((carline) => {
      // return carline.ofertas.map(offer => ({text: offer.legal, ref: offer.anchor}));
      return carline.ofertas.map((offer) => offer.legal);
    })
    .flat();
};

function HomePage(props: HomePageProps) {
  const { offers } = props;

  const trackingManager = useTrackingManager();
  const historyService = useFeatureServices()['s2:history'];

  const [showOffer, setShowOffer] = useState(false);
  const [selectedCarlineIndex, setSelectedCarlineIndex] = useState<number | null>(null);
  const [selectedCarline, setSelectedCarline] = useState<CarlineWithOffers | null>(null);
  const [selectedCarlineId, setSelectedCarlineId] = useState<number | null>(null);
  const [parentId, setParentId] = useState<number>(null);
  const [targetId, setTargetId] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [id, setId] = useState<string>(null);

  const letters = [...'abcdefghijklmnopqrstuvwxyz'];

  setGlobalDisclaimer();
  const disclaimerManager = useFeatureServices()['disclaimer-manager'].getScopedDisclaimerManager();
  disclaimerManager.registerReferenceDisclaimer(
    'footer-reference',
    'El responsable del tratamiento de tus datos es VOLKSWAGEN GROUP ESPAÑA DISTRIBUCIÓN, S.A.U., con la finalidad de atender tu solicitud de contacto y tus consultas. Te informamos que tienes derecho a retirar tu consentimiento en cualquier momento, así como a oponerte al tratamiento, limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a la portabilidad, mediante petición escrita a atencioncliente@volkswagen.es Puedes consultar con mayor detalle la información adicional sobre protección de datos aquí: https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html'
  );

  const refs = useRef(new Array(props.offers.length));
  const dataService = getDataServiceConfig();
  const config = useFeatureAppConfig();
  const faContent = useFaContent();
  const legales = useDisclaimerReference(getDisclaimers(offers)); // Registro de todos los legales

  //Eliminar el max width si es más de 4 ofertas y más de 1920px de viewport
  // La lógica también está en el componente OfferViewDesktop

  const viewportWidth = useViewportWidth();
  const { useMaxWidth } = useMaxWidthFunc(selectedCarline?.ofertas.length);

  //Las url antiguas de las ofertas no tienen el __app en el path, por lo que hay que añadirlo
  useEffect(() => {
    const search = window.location.search;
    const initialPath = window.location.pathname.split('/');

    if (initialPath.find((path) => path.includes('.app')) && !initialPath.includes('__app')) {
      const index = initialPath.findIndex((path) => path.includes('.app'));
      initialPath.splice(index, 0, '__app');
      const finalPath = initialPath.join('/');
      window.history.replaceState(null, null, `${finalPath}${search}`);
    }
  }, []);

  useEffect(() => {
    setLoading(false);
  }, []);

  //display ofertas
  const [numberOfOffers, setNumberOfOffers] = useState(1);
  const [offerPackageArray, setOfferPackageArray] = useState(null);
  const width = useWindowWidth();

  useEffect(() => {
    if (width < 560) {
      setNumberOfOffers(1);
    } else if (width < 960 && width > 559) {
      setNumberOfOffers(2);
    } else if (width < 1600 && width > 959) {
      setNumberOfOffers(3);
    } else {
      setNumberOfOffers(4);
    }
  }, [width]);

  const chunkArray = (myArray: Array<any>, chunk_size: number) => {
    let index = 0;
    let arrayLength = myArray.length;
    let tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
      let myChunk = myArray.slice(index, index + chunk_size);
      tempArray.push(myChunk);
    }

    return tempArray;
  };

  useEffect(() => {
    const aux = chunkArray(offers, numberOfOffers);
    setOfferPackageArray(aux);
  }, [numberOfOffers, offers]);

  useEffect(() => {
    if (offerPackageArray) {
      const { carline, index } = checkUrlForSelectedCarline();
      if (carline && (index || index === 0)) {
        if ((isPrivate(dataService) && carline.brand === 'V') || (isCommercial(dataService) && carline.brand === 'N')) {
          handleSelectedCarline(carline, index);
        } else {
          redirectToOtherPage(carline);
        }
      }
    }
  }, [offerPackageArray]);

  const checkUrlForSelectedCarline = (): { carline: CarlineWithOffers | null; index: number | null } => {
    const carlineUrlSplitted = window.location.pathname.split('/');
    const carlineUrl = carlineUrlSplitted[carlineUrlSplitted.length - 1].replace('.app', '');
    let carline = findCarlineInOffers(offers, carlineUrl);
    let index = carline ? findCarlineIndex(offerPackageArray, carline.code) : null;
    if (!carline && faContent.alias?.length > 0) {
      let { carline, index } = searchContentAlias(carlineUrl, faContent.alias);
      if (carline && (index !== undefined || index !== null)) {
        // modificar url
        handleUrlModification(carline, carlineUrl);
        return { carline, index };
      }
    }
    return { carline, index };
  };

  /**
   * En algunos casos se tiene que traducir el carline que llega en la url a otro que nos llega desde getOfertas.
   */
  const searchContentAlias = (
    carlineName: string,
    contentAlias: Alias[]
  ): { carline: CarlineWithOffers; index: number } => {
    const alias = contentAlias.find((c) => c.alias === carlineName);

    if (!alias) {
      return { carline: null, index: null };
    }

    const carline = findCarlineInOffers(offers, alias.destino);

    let index = carline ? findCarlineIndex(offerPackageArray, carline.code) : null;

    return { carline, index };
  };

  const handleCarlineClick = (carline: CarlineWithOffers, index: number, e: any) => {
    trackingManager.trackOffersModelSelectClick(carline, { contentId: carline.title });

    // En el caso de que sea un carline de la otra marca, tenemos que redirigir a la otra página.
    if ((isPrivate(dataService) && carline.brand === 'V') || (isCommercial(dataService) && carline.brand === 'N')) {
      unfoldOffers(carline, index, e);
    } else {
      redirectToOtherPage(carline);
    }
  };

  const redirectToOtherPage = (carline: CarlineWithOffers) => {
    if (isPrivate(dataService)) {
      window.location?.href = `${config.mainPage?.N}/${carline.name}.app?country=ES&language=es&campaign=ofertas&publisher=onehub-pkw&adpl=&adchan=wb&adplt=ofertas&adap=${carline.name}&adcr=ver_ofertas`;
    } else {
      window.location?.href = `${config.mainPage?.V}/${carline.name}.app?country=ES&language=es&campaign=ofertas&publisher=onehub-nfz&adpl=&adchan=wb&adplt=ofertas&adap=${carline.name}&adcr=ver_ofertas`;
    }
  };

  const unfoldOffers = (carline: CarlineWithOffers, index: number, e: any) => {
    const aux = document.getElementById(e.currentTarget.parentElement.id);
    aux.classList.add('showing-offers');
    handleSelectedCarline(carline, index, e);
    handleUrlModification(carline);
  };

  const handleUrlModification = (carline: CarlineWithOffers, oldCarlineName?: string, noCarline?: boolean) => {
    if (window.location?.pathname && window.history?.replaceState) {
      const search = window.location.search;
      const splittedPath = window.location.pathname.split('/');
      const offerInPath = offers.find((offer) =>
        splittedPath.find((path) => {
          if (path.replace('.app', '') === offer.name) {
            return offer;
          }
        })
      );

      if (noCarline) {
        if (!splittedPath.includes('__app')) {
          splittedPath.pop();
        } else {
          splittedPath.splice(splittedPath.length - 2, 2);
        }
      } else if (offerInPath || oldCarlineName) {
        const index = splittedPath.findIndex((path) =>
          path.includes(oldCarlineName ? oldCarlineName : offerInPath.name)
        );
        splittedPath[index] = splittedPath[index].replace(
          oldCarlineName ? oldCarlineName : offerInPath.name,
          carline.name
        );
      } else {
        splittedPath.push(`__app/${carline.name}.app`);
      }
      const finalPath = splittedPath.join('/');
      window.history.replaceState(null, null, `${finalPath}${search}`);
    }
  };

  const handleSelectedCarline = (carline: CarlineWithOffers, index: number, e?: any) => {
    setSelectedCarline(carline);
    setSelectedCarlineId(carline.code);
    setShowOffer(true);
    setId(letters[index]);
    setSelectedCarlineIndex(index);
    if (e) {
      setParentId(Number(e.currentTarget.parentElement.id));
      setTargetId(e.currentTarget.id);
    } else {
      setParentId(index);
      setTargetId(String(index));
    }
  };

  const setShowOfferToFalse = () => {
    const aux = document.getElementById(`${parentId}`);
    aux.classList.remove('showing-offers');
    if (refs.current[selectedCarlineIndex]) {
      window.scrollTo({
        behavior: 'smooth',
        top: aux.offsetTop,
      });
    }
    setShowOffer(false);
    handleUrlModification(selectedCarline, null, true);
  };

  const unSelectCarline = () => {
    setSelectedCarline(null);
    setSelectedCarlineId(null);
    setId(null);
  };

  //Gestión de infoPageService en SSR o CSR
  if (typeof window !== 'undefined') {
    if (selectedCarline) {
      const canonicalUrl = isPrivate(dataService)
        ? `${config.mainPage?.V}/__app/${selectedCarline.name}.app`
        : `${config.mainPage?.N}/__app/${selectedCarline.name}.app`;
      useInfoPageService(selectedCarline, canonicalUrl);
    }
  } else {
    // Server-side rendering
    const aux = historyService?.rootHistory.location.pathname.split('/').pop();
    let carline = findCarlineInOffers(offers, aux.replace('.app', ''));
    let canonicalUrl = null;
    if (carline) {
      if (isPrivate(dataService) && carline.brand === 'V') {
        canonicalUrl = `${config.mainPage?.V}/__app/${carline.name}.app`;
        useInfoPageService(carline, canonicalUrl);
      } else if (isCommercial(dataService) && carline.brand === 'N') {
        canonicalUrl = `${config.mainPage?.N}/__app/${carline.name}.app`;
        useInfoPageService(carline, canonicalUrl);
      }
    }
  }

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ display: 'none' }}>
          {offers.map((offer, index) => {
            return (
              <OfferCarlineCard
                key={`${index}-${offer.name}-${offer.code}-prov`}
                carline={offer}
                selectedCarlineId={selectedCarlineId}
                offerPackageArray={[]}
              />
            );
          })}
        </div>
      ) : (
        <React.Fragment>
          {offerPackageArray
            ? offerPackageArray.map((item: any, parentIndex: number) => {
                let auxClassName;
                let auxDesktopOfferClassName;
                if (parentIndex + 1 === offerPackageArray.length) {
                  auxClassName = 'last-row';
                  auxDesktopOfferClassName = 'last-row';
                } else {
                  auxClassName = 'other-rows';
                  auxDesktopOfferClassName = 'other-rows';
                }
                return (
                  <>
                    <MaxWidthLayout id="max-width-layout" useMaxWidth={true}>
                      <Layout
                        appearance={{
                          [Breakpoints.default]: [{ name: 'a', columns: 24 }],
                          [Breakpoints.b560]: [
                            { name: '.', columns: 2 },
                            { name: 'a', columns: 20 },
                            { name: '.', columns: 2 },
                          ],
                        }}
                        allowOverflowingContent
                      >
                        <OffersLineWrapper
                          key={`${parentIndex}-offersLine`}
                          id={`${parentIndex}`}
                          className={auxClassName}
                        >
                          {item.map((offer: any, childIndex: number) => {
                            return (
                              <OfferCarlineWrapper
                                id={offer.code}
                                onClick={(e: any) => {
                                  // historyService.history.push('/aaaa');
                                  handleCarlineClick(offer, childIndex, e);
                                }}
                                ref={(el) => (refs.current[childIndex] = el)}
                                key={childIndex}
                                className="offer-carline-card-wrapper"
                              >
                                <OfferCarlineCard
                                  key={`${childIndex}-${offer.name}-${offer.code}`}
                                  carline={offer}
                                  selectedCarlineId={selectedCarlineId}
                                  offerPackageArray={offerPackageArray}
                                />
                              </OfferCarlineWrapper>
                            );
                          })}
                        </OffersLineWrapper>
                      </Layout>
                    </MaxWidthLayout>
                    {showOffer && selectedCarline && parentId === parentIndex ? (
                      <MaxWidthLayout id="max-width-layout" useMaxWidth={useMaxWidth}>
                        <OfferContainer
                          carline={selectedCarline}
                          setShowOfferToFalse={setShowOfferToFalse}
                          showOffer={showOffer}
                          unSelectCarline={unSelectCarline}
                          showCard={true}
                          id={`${parentId + 10}`}
                          auxDesktopOfferClassName={auxDesktopOfferClassName}
                          parentId={`${parentId}`}
                        />
                      </MaxWidthLayout>
                    ) : null}
                  </>
                );
              })
            : null}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state: OffersState) => {
  return {
    offers: state.offers,
  };
};

export default connect(mapStateToProps)(HomePage);
